export { default } from './CheckeredFlag'
